import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Megaphone, GitBranch, FileText, MessageSquare,
  MessagesSquare, IndianRupee, ScrollText, Settings, LogOut, CreditCard,
  Filter, TrendingUp, Receipt,
} from "lucide-react";
import { getQrtToken, getQrtAdmin, qrtMe, clearQrtSession } from "../../apis/qrtAdmin";
import logo from "../../assets/i3.png";
import "../../styles/ping.css";

const NAV = [
  { to: "/qrt/overview", label: "Overview", icon: LayoutDashboard },
  { to: "/qrt/revenue", label: "Revenue", icon: TrendingUp },
  { to: "/qrt/users", label: "Users", icon: Users },
  { to: "/qrt/campaigns", label: "Campaigns", icon: Megaphone },
  { to: "/qrt/flows", label: "Flows", icon: GitBranch },
  { to: "/qrt/templates", label: "Templates", icon: FileText },
  { to: "/qrt/messages", label: "Messages", icon: MessageSquare },
  { to: "/qrt/billing", label: "Billing", icon: IndianRupee },
  { to: "/qrt/invoices", label: "Invoices", icon: Receipt },
  { to: "/qrt/service-usage", label: "Service msgs", icon: MessagesSquare },
  { to: "/qrt/plans", label: "Plans", icon: CreditCard },
  { to: "/qrt/funnel", label: "Funnel", icon: Filter },
  { to: "/qrt/audit", label: "Audit", icon: ScrollText },
  { to: "/qrt/settings", label: "Settings", icon: Settings },
];

const QrtLayout = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(getQrtAdmin());

  useEffect(() => {
    if (!getQrtToken()) {
      navigate("/qrt/login", { replace: true });
      return;
    }
    qrtMe()
      .then((res) => setAdmin(res.data?.data || null))
      .catch(() => {});
  }, [navigate]);

  if (!getQrtToken()) return null;

  const logout = () => {
    clearQrtSession();
    navigate("/qrt/login", { replace: true });
  };

  return (
    <div className="qrt-shell">
      <aside className="qrt-nav">
        <div className="qrt-brand">
          <img src={logo} alt="BluTec Ping" className="qrt-logo" />
          <div>
            <p>BluTec Ping</p>
            <span>Admin panel</span>
          </div>
        </div>
        <nav>
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `qrt-nav-item ${isActive ? "on" : ""}`}>
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="qrt-nav-foot">
          <div className="qrt-nav-admin">
            <p>{admin?.name || "Admin"}</p>
            <span>{admin?.role || ""}</span>
          </div>
          <button type="button" onClick={logout} title="Sign out" aria-label="Sign out">
            <LogOut size={15} />
          </button>
        </div>
      </aside>
      <main className="qrt-main">
        <Outlet />
      </main>
    </div>
  );
};

export default QrtLayout;
